import { render } from "./InventoryManager.vue?vue&type=template&id=00d99d0c&scoped=true"
import script from "./InventoryManager.vue?vue&type=script&lang=js"
export * from "./InventoryManager.vue?vue&type=script&lang=js"

import "./InventoryManager.vue?vue&type=style&index=0&id=00d99d0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d99d0c"]])

export default __exports__